import React, { useState } from 'react';
import Carousel from "../components/Carousel";
import Schema from '../components/Schema';

const projects = [
  {
    title: 'MRS. S.A. BORALESSA - 5KW',
    content: '5/4/1/1, Huludagoda Rd, Dehiwala - Mount Lavinia',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr11.jpg",
      "/Images/projects/pr12.jpg",
      "/Images/projects/pr13.jpg",
    ],
    
  },
  {
    title: 'MRS.N.P.I.DISSANAYAKA - 10KW',
    content: 'No.46/4, Hanwella Rd, Padukka.',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr21.jpg",
      "/Images/projects/pr22.jpg",
      "/Images/projects/pr23.jpg",
    ],
  },
  {
    title: 'MRS.N.P.I.DISSANAYAKA - 40KW',
    content: 'No.46/4, Hanwella Rd, Padukka.',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756111942/Screenshot_2025-08-25_142012_mzrhfo.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756111942/Screenshot_2025-08-25_142019_fqofnq.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756111942/Screenshot_2025-08-25_142025_fwhust.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756111941/Screenshot_2025-08-25_142031_weayj7.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756111939/Screenshot_2025-08-25_142038_lmhxbb.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756111899/Screenshot_2025-08-25_142042_piztqx.png"
    ],
  },
  {
    title: 'Mr.Jagath Halpandeniya - 8kw',
    content: 'No.4, Govikam Place, Diulpitiya, Boralasgamuwa.',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr31.jpg",
      "/Images/projects/pr32.jpg",
      "/Images/projects/pr33.jpg",
    ],
  },
  {
    title: 'Mr. N.A Manohara - 5Kw',
    content: 'Richmen place, 123/A/2/1, Peralanda, Ragama.',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr41.jpg",
      "/Images/projects/pr42.jpg",
      "/Images/projects/pr43.jpg",
    ],
  },
  {
    title: 'Mr.W Dharmasena - 5kw',
    content: 'No.11, Poregedara, Padukka',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr51.jpg",
      "/Images/projects/pr53.jpg",
      "/Images/projects/pr52.jpg",
    ],
  },
  {
    title: 'MRS. B.C.P.Mendis - 5kw',
    content: 'A/E/12-39, Ranpokunawatta',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr61.jpg",
      "/Images/projects/pr62.jpg",
      "/Images/projects/pr63.jpg",
    ],
  },
  {
    title: 'Mr.B.A.N Wijewardena - 5kw',
    content: '14/2/C, Dewananda Mw, Wewala, Piliyandala.',
    type: "SCI", // SCI Method
    images: [
      "/Images/projects/pr71.jpg",
      "/Images/projects/pr72.jpg",
      "/Images/projects/pr73.jpg",
    ],
  },
  {
    title: 'Mr. Gerald De Seram 20kw Reinstallation',
    content: 'Dehiwala,',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756112280/Screenshot_2025-08-25_142716_qedycc.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756112280/Screenshot_2025-08-25_142721_u7k1tl.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756112280/Screenshot_2025-08-25_142725_uopvay.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756112280/Screenshot_2025-08-25_142730_qfsprf.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756112279/Screenshot_2025-08-25_142736_z2iqwq.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756112279/Screenshot_2025-08-25_142742_qkfiff.png"
    ],
  },
  {
    title: 'Mr. Gihan Siriwardhane 6kW',
    content: 'Kaluthara South,',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113343/Screenshot_2025-08-25_144438_eoguks.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113343/Screenshot_2025-08-25_144457_no382t.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113343/Screenshot_2025-08-25_144504_xzusoi.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113342/Screenshot_2025-08-25_144450_m04k77.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113343/Screenshot_2025-08-25_144445_kwftqs.png"
    ],
  },
  {
    title: 'Mrs. Mah Kularathne. 5KW ',
    content: 'Mathugama',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113782/Screenshot_2025-08-25_145139_vbhxtr.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113782/Screenshot_2025-08-25_145156_oh1k0t.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113782/Screenshot_2025-08-25_145145_nhdqqy.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113781/Screenshot_2025-08-25_145150_tuwqkl.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756113781/Screenshot_2025-08-25_145150_tuwqkl.png"
    ],
  },
  {
    title: 'MR.A. U. Kandage 5KW',
    content: 'Nittabmuwa',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756114102/Screenshot_2025-08-25_145754_vweqcv.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756114103/Screenshot_2025-08-25_145737_rildoo.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756114104/Screenshot_2025-08-25_145719_uyt7o4.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756114103/Screenshot_2025-08-25_145749_t3nmco.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756114103/Screenshot_2025-08-25_145731_uvwgjc.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756114103/Screenshot_2025-08-25_145731_uvwgjc.png"
    ],
  },
  {
    title: 'Mr.Stanley Fernando 3kW Reinstallation',
    content: 'Vennappuwa',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756115358/Screenshot_2025-08-25_151847_shkt89.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756115358/Screenshot_2025-08-25_151837_ceedw7.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756115358/Screenshot_2025-08-25_151843_z1p087.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756115359/Screenshot_2025-08-25_151830_mk23bu.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756115360/Screenshot_2025-08-25_151227_v0nvtj.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756115360/Screenshot_2025-08-25_151233_t21wf7.png"
    ],
  },
  {
    title: 'MR. Niranjan De Silva',
    content: 'Mount Lavinia',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116405/Screenshot_2025-08-25_153154_fgp1pa.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116404/Screenshot_2025-08-25_153148_ypcnrl.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116404/Screenshot_2025-08-25_153159_pmyefe.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116403/Screenshot_2025-08-25_153217_tlzlfm.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116403/Screenshot_2025-08-25_153211_ewiszw.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116403/Screenshot_2025-08-25_153205_yuream.png"
    ],
  },
  {
    title: 'Mrs. S.A. Pushpa Kanthi 5kW',
    content: 'Mount Lavinia',
    type: "SCI", // SCI Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116910/Screenshot_2025-08-25_154356_cx7ysb.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116908/Screenshot_2025-08-25_154422_gndku7.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116910/Screenshot_2025-08-25_154407_zxdoxt.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116910/Screenshot_2025-08-25_154412_hwmjuz.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116911/Screenshot_2025-08-25_154402_ngktdz.png",
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756116910/Screenshot_2025-08-25_154356_cx7ysb.png"
    ],
  },
  {
    title: 'MELWIRE ROLLING PVT LTD',
    content: ' NO.21,TEMPLE RD, EKALA, JA ELA, SRI LANKA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756122199/Screenshot_2025-08-25_171302_hc5t8b.png"
    ],
  },
  {
    title: 'MELWIRE LANKA(SEEDUEA GI)',
    content: 'NO.12,LIYANAGEMULLA SEEDUWA, SRI LANKA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756122347/Screenshot_2025-08-25_171532_e3bbgu.png"
    ],
  },
  {
    title: 'MACKSONS TILES LANKA PVT LTD',
    content: 'NO. 264/A, ATULUGAMA RD, RADDEGODA, PARAGASTHOTA, BANGARAGAMA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756122433/Screenshot_2025-08-25_171701_i6ynad.png"
    ],
  },
  {
    title: 'R.G BROTHERS PVT LTD',
    content: 'NO.228,CANAL RD, ELAKANDA, WATTALA, SRI LANKA,',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756122575/Screenshot_2025-08-25_171921_rakqrl.png"
    ],
  },
  {
    title: 'ASSOCIATED SPECIALITY RUBBERS (PVT) LTD.',
    content: ' GETAHETHTHA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756122820/Screenshot_2025-08-25_172036_c5wam8.png"
    ],
  },
  {
    title: 'ASSOCIATED SPECIALITY RUBBERS (PVT) LTD.',
    content: ' KEGALLE',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756122972/Screenshot_2025-08-25_172436_p1xdgc.png"
    ],
  },
  {
    title: 'CLEAR POINT RESIDENCIES ',
    content: ' RAJAGIRIYA - WORLDS TALLEST ON-GRID SOLAR SYSTEM 185M',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123195/Screenshot_2025-08-25_172658_snsmjh.png"
    ],
  },
  {
    title: 'INDIKA PERERA ',
    content: '  THALAWATHUGODA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123328/Screenshot_2025-08-25_173055_sn0ne1.png"
    ],
  },
  {
    title: 'MALIK ',
    content: '  WATTALA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123459/Screenshot_2025-08-25_173326_ffkjlj.png"
    ],
  },
  {
    title: 'ARUNA ',
    content: '  HOMAGAMA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123597/Screenshot_2025-08-25_173609_nu9trh.png"
    ],
  },
  {
    title: 'MANOJ ',
    content: '   MORATUWA',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123697/Screenshot_2025-08-25_173730_mot5uk.png"
    ],
  },
  {
    title: 'WANIGANAYAKE ',
    content: '  COLOMBO-05',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123795/Screenshot_2025-08-25_173941_shpsrl.png"
    ],
  },
  {
    title: 'THANUJAN ',
    content: '  GRANDPAS',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756123905/Screenshot_2025-08-25_174045_vi2d0w.png"
    ],
  },
  {
    title: 'M.A.H KULARATHNA ',
    content: ' MATHUGAMA ',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756124078/Screenshot_2025-08-25_174356_me8uqy.png"
    ],
  },
  {
    title: 'DR.THUHARA ',
    content: '  RATHMALANA ',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756124177/Screenshot_2025-08-25_174520_xmjexh.png"
    ],
  },
  {
    title: 'PUSHPA KANTHI  ',
    content: ' MOUNT LAVINA ',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756124291/Screenshot_2025-08-25_174716_dt2ba1.png"
    ],
  },
  {
    title: 'RANATHUNGA ',
    content: ' BATTARAMULLA ',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756124374/Screenshot_2025-08-25_174856_roabul.png"
    ],
  },
  {
    title: 'RANATHUNGA ',
    content: ' BATTARAMULLA ',
    type: "Preventive", // Preventive Method
    images: [
      "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756124374/Screenshot_2025-08-25_174856_roabul.png"
    ],
  },

];

const Projects = () => {
  // const [expandedIndex, setExpandedIndex] = useState(null);
    const [expandedIndex] = useState(null);
  const [selectedType, setSelectedType] = useState("SCI"); // Default filter

  // const toggleExpand = (index) => {
  //   setExpandedIndex(expandedIndex === index ? null : index);
  // };

  const filteredProjects = projects.filter(
    (project) => project.type === selectedType
  );

  return (
    <div className="py-20 bg-[#f9f9f9]">
    <Schema />
      <div className="container mx-auto px-4">
        <h1 className="text-5xl font-bold text-black text-center mb-10">
          Our Projects
        </h1>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8">
        <button
          onClick={() => setSelectedType("Preventive")}
          className={`px-4 py-2 sm:px-6 sm:py-2 rounded-full font-medium text-sm sm:text-base ${
            selectedType === "Preventive"
              ? "bg-black text-white"
              : "bg-gray-200 text-gray-800"
          }`}
        >
          Preventive Maintenance with Antistatic - Anti-adherent Protection Coating
        </button>
        <button
          onClick={() => setSelectedType("SCI")}
          className={`px-4 py-2 sm:px-6 sm:py-2 rounded-full font-medium text-sm sm:text-base ${
            selectedType === "SCI"
              ? "bg-black text-white"
              : "bg-gray-200 text-gray-800"
          }`}
        >
          Type SCI Installation Method
        </button>
      </div>


        {/* Projects */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {filteredProjects.map((project, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-3xl overflow-hidden transition hover:scale-[1.01]"
          >
            {/* Title and Content on top */}
            <div className="p-6">
              <h5 className="text-xl font-semibold text-gray-900 mb-2">
                {project.title}
              </h5>
              <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                {project.content}
              </p>
              {/* Project Type Section */}
              <p className="text-xs font-medium text-gray-500 uppercase mb-3">
                Type: {project.type === "SCI" ? "SCI Method" : "Preventive Maintenance"}
              </p>
            </div>

            {/* Carousel */}
            <div className="w-full aspect-w-4 aspect-h-3">
              <Carousel slides={project.images} />
            </div>

            {/* Details Section */}
            {expandedIndex === index && (
              <div className="p-6 mt-4 text-sm text-gray-700 leading-relaxed">
                {project.type === "SCI" && project.method && (
                  <>
                    <p>
                      <strong>Strategy:</strong> {project.method.strategy}
                    </p>
                    <p className="mt-2">
                      <strong>Creativity:</strong> {project.method.creativity}
                    </p>
                    <p className="mt-2">
                      <strong>Implementation:</strong> {project.method.implementation}
                    </p>
                  </>
                )}
                {project.type === "Preventive" && project.maintenance && (
                  <>
                    <p>
                      <strong>Inspection:</strong> {project.maintenance.inspection}
                    </p>
                    <p className="mt-2">
                      <strong>Testing:</strong> {project.maintenance.testing}
                    </p>
                    <p className="mt-2">
                      <strong>Replacement:</strong> {project.maintenance.replacement}
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      </div>
    </div>
  );
};

export default Projects;